import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JsonExportService {
    jsonanzahl: number;
    language: string;
    placeholder: object;
    info: string;
    stddefault: string = "ohne";
    dokid: number = 0;
    completejson: any;

    constructor(
        http: HttpClient,

    ) { }


    downloadFile(data, filename = 'data') {
        const csvData = data;
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);

    }

    json2output(json: any, mappingall: any, language: string) {


        this.language = language;
        // mappinginput.elements Sortierung sollte Aufgabe des Eingabe-/Erstellungsformulars sein => mappinginput.elements ist hier schon in richtiger Reihenfolge.
        // mappinginput kann array von Mappings sein. Unter wird dann anhand des Dokumenttyps ausgewählt, welches genommen wird.
        // langsetting gibt an, welche Sprache für elements verwendet wird. Wird als globale Variable für alle gesetzt.
        // ----------------------START - Konfigurationsteil: wird in Angular nicht gebraucht --------------------------
        //D language = langsetting;
        //D mappingall = JSON.parse(mappinginput.value);
        // ----------------------ENDE - Konfigurationsteil ------------------------------------------------------------
        // welcher Modus wird angewendet, momentan gibt es nur fud-json. Bei mehren Modis zu überlegen, ob in übergeordnetet Funktion auszulagern, die dann bei Modus fud-json ein Funktion (if-part) aufruft.
        let inputformat: string = "fud-json";
        let ausgabe: string = "";
        let error: string = "";
        let etrenner: string = "";
        let etrenneroption: string = "";
        let elabel: string = "";
        let defaultwert: any = "";
        //im JS-Modul können auch nur die Felder angzeigt werden anstatt die Inhalte. Macht in Produktivversionen aber weniger Sinn (oder?)
        // let jsonanzahl: number; //Frage@Peter jsonanzahl schon in Service definiert => hier überflüssig?
        if (inputformat == "fud-json") {
            let modus: string = "none";
            //completejson wird durch Weglassen von Deklaration (let, var, const) zur globalen Variabel, auf die später zurückgegriffen werden kann (usefunction!).
            //D completejson = JSON.parse(jsoninput.value);
            // completejson (Js) == JSON (Ang)
            // handelt es sich bei json um eine Liste oder ein einzelnes JSON-Dokument (Liste bezieht sich auf Trefferliste, von daher wird Element .hits geprüft, ob vorhanden ist).
            if (Array.isArray(json)) {
                this.jsonanzahl = json.length;
                if (this.jsonanzahl > 11000) {
                    error = `Anzahl der Dokumente (${this.jsonanzahl}) > 11000. Es werden aber nur die ersten 1000 Dokumente auf einmal exportiert!`;
                    if (!this.info.includes(error)) {
                        this.info = this.myconcat([this.info, "<br />", error]);
                    };
                    console.log(error);
                    this.jsonanzahl = 11000;
                }
                modus = "list";
            } else if (typeof json.hits === "undefined") {
                this.jsonanzahl = 1;
                modus = "single";
            } else {
                json = json.hits.hits;
                this.jsonanzahl = json.length;
                if (this.jsonanzahl > 11000) {
                    error = `Anzahl der Dokumente (${this.jsonanzahl}) > 11000. Es werden aber nur die ersten 1000 Dokumente auf einmal exportiert!`;
                    if (!this.info.includes(error)) {
                        this.info = this.myconcat([this.info, "<br />", error]);
                    };
                    console.log(error);
                    this.jsonanzahl = 11000;
                }
                modus = "list";
            }
            let setlabel = "todo";
            for (let n = 0; n < this.jsonanzahl; n++) {
                // Schleife über alle Dokumente im json
                //jsonarray = komplettes Json für ein FuD-Dokument: globale Variable, so dass auf sie z.B. mit reloadjson4doc zurückgegriffen werden kann.
                //in das globale Object placeholder können mit setPlaceholder Strings gespeichert werden, die mit getPlaceholder wieder abgerufen werden können. Dabei wird im epart immer eine "Variable" angegeben, die als placeholder.epart dann im Laufe des Durchlaufs abgerufen werden kann. Zu Beginn jedes neuen Datensatz wir Placeholder gelöscht.
                let mapping: any;
                if (modus === "single") {
                    var jsonarray = json._source; //G
                } else if (modus === "list") {
                    jsonarray = json[n]._source;
                } else {
                    ausgabe = "Falscher Modus: " + modus;
                    return ausgabe;
                };
                let jsondoctyp = jsonarray['docTyp']['id'];
                //dokid: globale Variable, da man sie später bei findeabqDocs noch braucht.
                this.dokid = jsonarray.ID;
                if (Array.isArray(mappingall)) {
                    for (let i9 = 0; i9 < mappingall.length; i9++) {
                        mapping = mappingall[i9];
                        if (jsondoctyp == mapping.fuddoctyp) {
                            break;
                        };
                    }
                } else {
                    mapping = mappingall;
                };
                let outputmodus = mapping.outputmodus;
                if (jsondoctyp !== mapping.fuddoctyp) {
                    error = `Fehler: Dokument-ID. ${this.dokid}: Dokumenttyp ${jsondoctyp} aus Elastic und Dokumenttyp ${mapping.fuddoctyp}, für den das Mapping erstellt wurde, stimmen nicht überein!`;
                    console.log(error);
                } else {
                    let docend: string = "";
                    if (!outputmodus) {
                        error = `Outputmodus ist nicht definiert => Abbruch!`;
                        if (!this.info.includes(error)) {
                            this.info = this.myconcat([this.info, "<br />", error]);
                        };
                        return error;
                    }

                    // Einlesen der Trenner von Elementen und Elementlisten.
                    if (mapping.elementtrenner) {
                        etrenner = mapping.elementtrenner.trenner;
                        etrenneroption = mapping.elementtrenner.option;
                    }

                    let epre = mapping.elementpre;
                    let epost = mapping.elementpost;
                    let elistpre = mapping.elistpre;
                    let elistpost = mapping.elistpost;

                    // Wenn es pretext für ausgabe gibt, wird dieser Text hier in ausgabe an den Anfang gesetzt.
                    if (mapping.pretext) {
                        ausgabe = mapping.pretext;
                    }

                    // für die Modi 'csv' und 'htmltabelle' wird einen headerzeile generiert.
                    // TODO: für 'detailansicht' könnte man auch heading-Zeile anhand von Kriterien definieren, z.B. anhand etemplate: heading.
                    if ((outputmodus == "csv" || outputmodus == "tsv" || outputmodus === "htmltabelle") && (setlabel == "todo")) {
                        //für diese Modus muss die Labelzeile nur 1x gesetzt werden. Wenn das geschehen ist, braucht es für die restlichen Spalten nicht mehr gemacht werden!
                        let zbegin;
                        if (epre) zbegin = epre.replace("<td>", "<th>");
                        let zend;
                        if (epost) zend = epost.replace("</td>", "</th>");
                        ausgabe = this.myconcat([ausgabe, elistpre]);
                        for (let i = 0; i < mapping.elements.length; i++) {
                            let labelarray = mapping.elements[i].elabel;
                            let labelinlang = this.readlabel(labelarray, language);
                            ausgabe = this.myconcat([
                                ausgabe,
                                zbegin,
                                labelinlang,
                                zend,
                                etrenner,
                            ]);
                        }
                        ausgabe = this.myconcat([ausgabe, elistpost]);
                        setlabel = "labeldone";
                    };

                    if (outputmodus.startsWith("webpreview")) {
                        // um jedes Dokument kommt ein div mit class = 'fuddok' und name='_id'
                        let docbegins = `<div id='${this.dokid}' class='fuddok'>`;
                        ausgabe = this.myconcat([ausgabe, docbegins]);
                        docend = "</div>";
                    }
                    for (let mi = 0; mi < mapping.elements.length; mi++) {
                        // Schleife über alle Ausgabeelemente in mapping
                        let noshow: string = "inaktiv";
                        let ausgabeblock: string = "";
                        let econtent = mapping.elements[mi].econtent; // array of element(s)
                        let notes: string = "";
                        let elementinhalt: string = "";
                        let econtentclass: string = "";
                        let divend: string = "";
                        if (outputmodus.startsWith("webpreview")) {
                            // default: Jede Zeile wird in ein eigenes div class='zeile' geschrieben!
                            let labelinlang = this.readlabel(mapping.elements[mi].elabel, language);
                            let csslabel = mapping.elements[mi].elabelclass;
                            if (typeof csslabel === "undefined") {
                                csslabel = "label";
                            };
                            if (labelinlang !== "n/a") {
                                elabel = this.myconcat([
                                    '<div class="',
                                    csslabel,
                                    '">',
                                    labelinlang,
                                    "</div>"
                                ]);
                            } else {
                                elabel = "";
                            };
                            notes = mapping.elements[mi].enotes;
                            if (notes) {
                                notes = "<div class='subnotes'>" + notes + "</div>";
                            };
                        } else {
                            // bei den beiden anderen Modi (csv und htmltabelle) stehen labels schon in Überschriftenzeile.
                            // ToDo: verallgemeinern und von Modi unabhängig programmieren (vertikal vs. horizontal).
                            elabel = "";
                        };
                        let eclass = mapping.elements[mi].eclass;
                        if (!eclass && outputmodus.startsWith("webpreview")) {
                            eclass = `<div class='zeile'>`;
                        } else if (eclass && outputmodus.startsWith("webpreview")) {
                            eclass = `<div class='${eclass}'>`;
                        };

                        if (outputmodus.startsWith("webpreview")) {
                            econtentclass = `<div class='content'>`;
                            divend = `</div>`;
                        };

                        for (let mii = 0; mii < econtent.length; mii++) {
                            // Schleife über econtent = alle Elemente des Feldinhalts.
                            let varcontent: any;//varcontent ist Hilfvariabel für Aufbau des elementinhalts.
                            let vartyp = econtent[mii].etype;
                            let varinhalt = econtent[mii].epart;
                            let edefault = econtent[mii].default;
                            let fudfeldtyp = econtent[mii].fudfeldtyp;
                            let prestring = econtent[mii].epartpre;
                            let poststring = econtent[mii].epartpost;
                            let epartfunction = econtent[mii].usefunction;
                            let snotes = econtent[mii].enotes;
                            let subdef = econtent[mii].subcontent;
                            let blocktrenner = econtent[mii].blocktrenner;
                            let espez = econtent[mii].espez;
                            let elang = econtent[mii].elang;
                            let labelarray = econtent[mii].elabel;
                            //elabel ist ein Array, das objects mit labelstring und lang enthält. 
                            let labelresult = this.readlabel(labelarray, elang);
                            let labelelang = labelresult['labelinlang'];
                            let epartlabelclass = labelresult['labelclass'];
                            let epartlabel: string = "";
                            if (labelelang && epartlabelclass) {
                                epartlabel = `<div class='${epartlabelclass}'>${labelelang}</div>`;
                            } else if (labelelang) {
                                epartlabel = `<div class='sublabel'>${labelelang}</div>`;
                            };
                            let eclass1 = econtent[mii].eclass;
                            let eclass1end;
                            if (eclass1) {
                                eclass1 = `<div class='${eclass1}'>`;
                                eclass1end = `</div>`;
                            };
                            if (snotes) {
                                snotes = `<span class='subnotes'>${snotes}</span>`;
                            };

                            let epartopt;
                            // console.log(`1.Ebene: ${vartyp}: ${varinhalt}`);
                            if ((!elang) || (elang == language)) {
                                // epart wird nur geschrieben, wenn keine Sprache hinterlegt ist (= default-Wert für alle Sprachen) oder der String für die gewählte Sprache verwendet werden soll.
                                if (vartyp == "string") {
                                    // epart ist eine Zeichenfolge, die direkt so als Feldinhalt übernommen werden kann.

                                    varcontent = varinhalt;
                                    noshow = "weiteres Element";
                                    if (this.stddefault == "epart") {
                                        epartopt = varinhalt;
                                    };
                                } else if ((vartyp == "json") || (vartyp == "htmltext")) {
                                    // Die Angabe in epart ist ein FuD-Json-Feld, deren Wert direkt aus json übernommen werden kann.
                                    //durch linkgroup obsolet: für w (und q-Felder): usefunction exlink (w) oder inlink (q).
                                    //bei json bleibt getContent auf selber Ebene => snotes wird in getContent schon geschrieben und kann daher hier gelöscht werden. Ebenso wie prestring, poststring sowie eclass1 und eclass1end;
                                    //epartfct wird in getContent augeführt und braucht von daher hier nicht mehr aufgerufen zu werden.
                                    varcontent = this.getContent(econtent[mii], jsonarray, "", "", "", "");
                                    snotes = "";
                                    prestring = "";
                                    poststring = "";
                                    eclass1 = "";
                                    eclass1end = "";
                                    epartlabel = "";

                                    noshow = "weiteres Element";
                                    if (this.stddefault == "epart") {
                                        epartopt = varcontent;
                                    };
                                } else if ((vartyp == "child") || (vartyp == "LmAdd")) {
                                    let childcontent = jsonarray[varinhalt];
                                    if ((childcontent) && (vartyp == "LmAdd")) {
                                        //bei LmAdd müssen wir noch eins vorwärts schieben. Funktioniert in der verkürzten Schreibweise nur bei lre3/4 auf oberster Ebene, da bei lre1/lre2 erstmal block als etype geschrieben werden muss.
                                        childcontent = childcontent.LmAdd;
                                    };
                                    if (childcontent || this.stddefault !== "ohne") {

                                        varcontent = this.getContent(subdef, childcontent, "", "", "", "");
                                    };
                                    if ((this.stddefault == "epart") && (vartyp = "child")) {
                                        epartopt = varinhalt + "." + varcontent;
                                    } else if ((this.stddefault == "epart") && (vartyp = "LmAdd")) {
                                        epartopt = varinhalt + ".LmAdd." + varcontent;
                                    };
                                    noshow = "weiteres Element";
                                    // wenn Darstellung inline erfolgen soll, dann braucht man im Mapping keine Klasse anzugeben!
                                } else if (vartyp == "block") {
                                    // epart ist entweder lre-Feld oder wiederholbarer Block.
                                    if (epartfunction) {
                                        varcontent = this.usefunction(epartfunction, varinhalt, subdef, jsonarray, prestring, poststring, espez, "");
                                    } else {
                                        let block = jsonarray[varinhalt];
                                        if ((block) || (this.stddefault !== "ohne")) {
                                            varcontent = this.getContent(subdef, block, blocktrenner, espez, eclass1, eclass1end);
                                            eclass1 = "";
                                            eclass1end = "";
                                        };
                                    };
                                    noshow = "weiteres Element";
                                    if (this.stddefault == "epart") {
                                        if (fudfeldtyp == "s") {
                                            epartopt = `<span class="subzeile">${varinhalt}(${fudfeldtyp}).</span>${varcontent}`;
                                        } else if (fudfeldtyp) {
                                            epartopt = `${varinhalt}.${varcontent}(${fudfeldtyp})`;
                                        } else {
                                            epartopt = `${varinhalt}.${varcontent}`;
                                        };
                                    };
                                } else if (vartyp == "anhangblock") {
                                    //epart ist k- oder m-Feld.
                                    // in espez steht maximale Anzahl der Felder.
                                    // während die Definition des Felder in subdef steht, bleibt man im JSON auf selber Ebene!
                                    if (isNaN(espez)) {
                                        console.log(`espez ist keine Zahl: ${espez}. Hier muss aber die maximale Anzahl der m-, bzw. k-Felder stehen, ansonsten kann Anhang nicht ausgegeben werden!`);
                                    } else {
                                        for (let dignr = 0; dignr < espez; dignr++) {
                                            let singleanhang: any;
                                            for (let subanhang = 0; subanhang < subdef.length; subanhang++) {
                                                let anhangteil: any = this.getContent(subdef[subanhang], jsonarray, blocktrenner, dignr, eclass1, eclass1end);
                                                if (anhangteil) {
                                                    singleanhang = this.myconcat([singleanhang, anhangteil]);
                                                };
                                            };
                                            if (singleanhang && varcontent) {
                                                varcontent = this.myconcat([varcontent, blocktrenner, singleanhang]);
                                            } else if (singleanhang) {
                                                varcontent = singleanhang;
                                            };
                                        };
                                    };
                                    if (this.stddefault == "epart") {
                                        epartopt = varinhalt;
                                    };
                                    noshow = "weiteres Element";
                                } else if (vartyp == "group") {
                                    //bei group muss der subcontent ausgelesen werden, der die Gruppe bildet. Allerdings passiert kein Vorschub in den Ebenen => dass das jsonarray gleich bleibt. 
                                    // console.log(jsonarray);
                                    // console.log(subdef);
                                    if (epartfunction) {
                                        varcontent = this.usefunction(epartfunction, varinhalt, subdef, jsonarray, prestring, poststring, espez, "");
                                    } else {
                                        varcontent = this.getContent(subdef, jsonarray, blocktrenner, espez, eclass1, eclass1end);
                                    };
                                    noshow = "weiteres Element";
                                    if (this.stddefault == "epart") {
                                        epartopt = varcontent;
                                    };
                                } else if (vartyp == "linkgroup") {
                                    if (!epartfunction) {
                                        //wird immer gesetzt. Da inlink und exlink mittlerweile dasselbe sind, ist es egal, welcher verwendet wird.
                                        epartfunction = "inlink";
                                    };
                                    varcontent = this.usefunction(epartfunction, varinhalt, subdef, jsonarray, prestring, poststring, espez, "");
                                    if (this.stddefault == "epart") {
                                        epartopt = varcontent;
                                    };
                                } else if (vartyp == "renderimage") {
                                    varcontent = `<img src="${varinhalt}" alt="Anzeige von ${varinhalt}">`
                                    if (this.stddefault == "epart") {
                                        epartopt = `${varinhalt} (Bildanzeige)`;
                                    };
                                } else if (vartyp == "search") {
                                    let queryinhalt = econtent[mii].query;
                                    if (queryinhalt) {
                                        varcontent = this.fct_abqblock(this.dokid, subdef, queryinhalt, econtent[mii]);
                                    } else {
                                        varcontent = "Keine Suche nach abq-Feld spezifiziert!";
                                    };
                                    if (this.stddefault == "epart") {
                                        epartopt = `${queryinhalt} (Suchfeld für ID in anderem Dokument)`;
                                    };
                                } else if (vartyp == "setPlaceholder") {
                                    varcontent = this.getContent(subdef, jsonarray[varinhalt], "", "", "", "");
                                    this.placeholder[varinhalt] = varcontent;
                                    varcontent = "";
                                    if (this.stddefault == "epart") {
                                        epartopt = `Platzhalter ${varinhalt}`;
                                    };
                                } else if (vartyp == "getPlaceholder") {
                                    varcontent = this.placeholder[varinhalt];
                                    if (this.stddefault == "epart") {
                                        epartopt = `Platzhalter ${varinhalt}`;
                                    };
                                } else if (vartyp == "noshow") {
                                    // epart/element wird nicht angezeigt! Ist aber nur ein Teil davon mit noshow gekennzeichnet, so wird nur dieser nicht geschrieben => Überprüfen, ob man a)  
                                    //#TOTHINK
                                    snotes = "";
                                    notes = "";
                                    varcontent = "";
                                    defaultwert = "";
                                    // Wenn die anderen Teile des Elements einen anderen etype als 'noshow' haben, sollen diese Parts ja geschrieben werden. Von daher bekommen diese Parts den 'noshow'-Wert 'weiteres Element'. 
                                    if (noshow !== "weiteres Element") {
                                        noshow = "aktiv";
                                    };
                                } else {
                                    // Typ ist bisher noch nicht definiert worden.
                                    // LmAdd kann nur auf block-Ebene als etype vorkommen.
                                    error = `etype ${vartyp} mit epart ${varinhalt} ist noch nicht definiert!`;
                                    if (!this.info.includes(error)) {
                                        this.info = this.myconcat([this.info, "<br />", error]);
                                    };
                                    console.log(error);
                                };
                            } else {
                                varcontent = "";
                                defaultwert = "";
                            };
                            // console.log(`1.Ebene: ${vartyp}: ${varinhalt}: ${varcontent}`);
                            if ((this.stddefault == "epart") && (vartyp !== "noshow")) {
                                //#TODO: Ausgabe von nur jsonname und feldtyp
                                let fudtp;
                                if ((fudfeldtyp) && ((vartyp !== "json") && (vartyp !== "htmltext") && (vartyp !== "block"))) {
                                    fudtp = `(${fudfeldtyp})`;
                                };
                                //Xlet optionepart = this.myconcat([epartopt, fudtp]);
                                elementinhalt = this.myconcat([elementinhalt, epartlabel, eclass1, '<span class="anderefarbe">', prestring, '</span>', varcontent, '<span class="anderefarbe">', poststring, '</span>', eclass1end, snotes]);
                            } else if (varcontent) {
                                elementinhalt = this.myconcat([elementinhalt, epartlabel, eclass1, prestring, varcontent, poststring, eclass1end, snotes]);
                            } else if (edefault) {
                                if (!elang || (this.language == elang)) {
                                    defaultwert = this.getContent(edefault, jsonarray, "", "", "", "");
                                    elementinhalt = this.myconcat([elementinhalt, epartlabel, eclass1, prestring, defaultwert, poststring, eclass1end, snotes]);
                                }
                            } else if ((this.stddefault !== "ohne") && (vartyp !== "noshow")) {
                                elementinhalt = this.myconcat([elementinhalt, epartlabel, eclass1, prestring, this.stddefault, poststring, eclass1end, snotes]);
                            };
                        }
                        //csv: Zeilenausgabe!
                        let textmarker;
                        if (elementinhalt && (outputmodus == "csv" || outputmodus == "tsv")) {
                            // Anführungszeichen werden im csv doppelt escapt. Dies ist vor allem wichtig, wenn \n in String vorhanden ist, das durchaus sein kann.
                            elementinhalt = elementinhalt.replace(/["]/g, '""');
                            //Bei csv muss um jeden Zelleninhalt ein "" gelegt werden, damit Linebreaks keinen neue Zeile bedingen!
                            textmarker = '"';
                        };
                        let writeelement = mapping.elements[mi].writeelement;
                        if (writeelement) {
                            if (writeelement[0] == "econtent") {

                                //hier wird der Inhalt des Elementes überprüft, wenn Bedingung für den gesamtnen econtent vorliegt. Wenn diese nicht erfüllt ist => elementinhalt wird auf "" gesetzt!
                                if (!this.checkwelement(elementinhalt, writeelement)) {
                                    elementinhalt = "";
                                };
                            };
                        };

                        if (!elementinhalt && outputmodus == "webpreview") {
                            // im webpreview soll element NICHT geschrieben werden, wenn es leer ist. Ggf. noch option zum ein und ausschalten anbringen!
                            // webpreview_allefelder z.B.
                            noshow = "aktiv";
                        };

                        if (noshow != "aktiv") {
                            if (eclass) {
                                if (eclass.startsWith("<div class='heading")) {
                                    //bei eine Überschriftenklasse wird kein Label und kein content geschrieben!
                                    ausgabeblock = this.myconcat([
                                        ausgabeblock,
                                        eclass,
                                        textmarker,
                                        epre,
                                        elementinhalt,
                                        epost,
                                        textmarker,
                                        divend,
                                        epost,
                                        notes
                                    ]);
                                } else {
                                    ausgabeblock = this.myconcat([
                                        ausgabeblock,
                                        eclass,
                                        elabel,
                                        econtentclass,
                                        textmarker,
                                        epre,
                                        elementinhalt,
                                        epost,
                                        textmarker,
                                        divend,
                                        divend,
                                        epost,
                                        notes
                                    ]);
                                };
                            } else {
                                ausgabeblock = this.myconcat([
                                    ausgabeblock,
                                    eclass,
                                    elabel,
                                    econtentclass,
                                    textmarker,
                                    epre,
                                    elementinhalt,
                                    epost,
                                    textmarker,
                                    divend,
                                    divend,
                                    epost,
                                    notes
                                ]);
                            };
                        };
                        if (etrenneroption == "nolast" && mi == mapping.elements.length) {
                            // wenn eine Zeile geschrieben wird, gibt es Formate, die keinen Abschlusstrennung brauchen, z.B. csv. Ein \t am Schluss würde weitere leere Spalte erzeugen => option nolast!
                            // ausgabeblock ist bei csv = Zeile! elementinhalt ist Zelleninhalt => Einsatz 'nolast' erst nach letztem Element der Zeile!
                            //=> ausgabeblock bleibt wie er ist.
                        } else {
                            ausgabeblock = this.myconcat([
                                ausgabeblock,
                                etrenner
                            ]);
                        }
                        ausgabe = this.myconcat([ausgabe, ausgabeblock]);
                    };
                    ausgabe = this.myconcat([elistpre, ausgabe, elistpost, docend]);
                };
            };
            this.downloadFile(ausgabe)
            // return ausgabe;
        } else {
            error = `Modus '${inputformat}' ist unbekannt => Abbruch!`;
            if (!this.info.includes(error)) {
                this.info = this.myconcat([this.info, "<br />", error]);
            };
            console.log(error);
            return error;
        }
    }

    myconcat(eingabearray: Array<any>) {
        // um undefinierte Werte hier nicht mit reinzuschreiben, wird array.prototyp.join verwendet. Damit nicht Komma als Trennzeichen verwendet wird (default) => '' als Parameter.
        return eingabearray.join("");
    }

    lmaddcontent(lrecontent: object, lmaddfname: string) {
        //lrecontent: Objekt des jeweiligen lre-Elementes
        //lmaddinput: Festlegung: lmAdd~~field, z.B. lmAdd~~gnd
        for (let lmaddnr in lrecontent) {
            //LmAdd-Objekte sind momentan DHIParis wie folgt aufgebaut: tid, field, val
            //im Webinar schon: Feldname: Feldinhalt, da wird diese Funktion nicht mehr gebraucht, da es mit splitebenen funktionieren müsste.
            if (lmaddfname == lrecontent[lmaddnr].field) {
                return lrecontent[lmaddnr].val;
            }
        }
    }

    getContent(mapdef: any, jsoncontent: any, btrenner: string, merkvar: any, blockclass: string, blockclassend: string) {
        // element = label contentclass (pre getContent post)*n endcontentclass
        //Ausnahme: jsoncontent wird als Array übergeben, sollte aber eigentlich ein Objekt sein oder? #TOCHECK
        // if (Array.isArray(jsoncontent) && jsoncontent.length == 1) {
        //     singlejson = jsoncontent[0];
        // } else {
        //     console.log("Muss noch programmiert werden: jsoncontent in getContent ist array > 1!")
        // };
        let rueckgabe: any;
        let hcontent: any;
        if (this.stddefault == "epart") {
            rueckgabe = this.readepart(mapdef, jsoncontent, merkvar);
        } else if (Array.isArray(jsoncontent)) {
            if (jsoncontent.length == 0) {
                hcontent = this.readepart(mapdef, jsoncontent, merkvar);
                if (rueckgabe) {
                    rueckgabe = this.myconcat([rueckgabe, btrenner, blockclass, hcontent, blockclassend])
                } else {
                    rueckgabe = this.myconcat([rueckgabe, blockclass, hcontent, blockclassend]);
                };
            } else {
                for (let j = 0; j < jsoncontent.length; j++) {
                    hcontent = this.readepart(mapdef, jsoncontent[j], merkvar);
                    if (rueckgabe) {
                        rueckgabe = this.myconcat([rueckgabe, btrenner, blockclass, hcontent, blockclassend])
                    } else {
                        rueckgabe = this.myconcat([rueckgabe, blockclass, hcontent, blockclassend]);
                    };
                };
            };
        } else if (typeof jsoncontent === "object") {
            hcontent = this.readepart(mapdef, jsoncontent, merkvar);
            rueckgabe = this.myconcat([rueckgabe, hcontent]);
        } else if (!jsoncontent) {
            hcontent = this.readepart(mapdef, jsoncontent, merkvar);
            if (this.stddefault == "n/a") {
                rueckgabe = this.readepart(mapdef, jsoncontent, merkvar);
            };
        } else {
            console.log("fct getContent: Was ist das? Noch nicht programmiert!");
            console.log(jsoncontent);
        };

        return rueckgabe;
    }

    readepart(edef: any, singlejson: any, merkvar: string) {
        let returnvalue: string = "";
        let mapdef: any;
        let hcontent: string = "";
        let eparttp: string = "";
        if ((!edef) && (this.stddefault !== "epart")) {
            //wenn es keine Subdefinition gibt, ist man fertig.
            return returnvalue;
        };
        if (!Array.isArray(edef)) {
            mapdef = [edef];
        } else {
            mapdef = edef;
        };
        console.log(mapdef, mapdef.length)
        for (let i = 0; i < mapdef.length; i++) {
            let etype = mapdef[i].etype;
            let epart = mapdef[i].epart;
            let edefault = mapdef[i].default;
            let fudfeldtyp = mapdef[i].fudfeldtyp;
            //würden um jeden econtent gelegt!
            let prestring = mapdef[i].epartpre;
            let poststring = mapdef[i].epartpost;
            let elang = mapdef[i].elang;
            let epartclassend: string = "";
            let epartclass = mapdef[i].eclass;
            if (epartclass) {
                epartclass = `<div class='${epartclass}'>`;
                epartclassend = `</div>`;
            };
            //elabel ist ein Array, das objects mit labelstring und lang enthält. 
            let labelresult = this.readlabel(mapdef[i].elabel, elang);
            let labelinlang = labelresult['labelinlang'];
            let epartlabelclass = labelresult['labelclass'];                                        
            // Wenn eine Klasse für ein Label angegeben ist, z.B. inline, um das Label ohne weitere Formatierung vor den content zu setzen, MUSS es angegeben werden. Ansonsten wird, wenn ein Label angegeben ist, die Klasse 'sublabel' verwendet!
            // Wenn kein Label angegeben ist, wird auch kein div-Tag für das Label geschrieben.
            let epartlabel:string = "";
            if (labelinlang && epartlabelclass) {
                epartlabel = `<div class='${epartlabelclass}'>${labelinlang}</div>`;
            } else if (labelinlang) {
                epartlabel = `<div class='sublabel'>${labelinlang}</div>`;
            };
            let epartsubcontent = mapdef[i].subcontent;
            let epartusefct = mapdef[i].usefunction;
            let espez = mapdef[i].espez;
            let subnotes = mapdef[i].enotes;
            if (subnotes) {
                subnotes = `<span class='subnotes'>${subnotes}</span>`;
            } else {
                subnotes = mapdef[i].epartnotes;
                if (subnotes) {
                    subnotes = `<span class='subnotes'>${subnotes}</span>`;
                };
            };
            let blocktrenner = mapdef[i].blocktrenner;
            // console.log(`    n-te Ebene: ${etype}: ${epart}`);
            // if ((blocktrenner) && (i > 0) && (rueckgabe)) {
            //     rueckgabe = this.myconcat([rueckgabe,blocktrenner]);
            // };
            let subID: string = "";
            if (singlejson) {
                subID = singlejson.subID;
            };
            if (subID) {
                //wenn es eine subID gibt, dann handelt es sich um ein Feld innerhalb eines s-Feldes. Dieses muss überprüft werden, ob es auch zu dem s-Feld gehört, dass eine Ebene drüber angegeben ist. Von daher muss die subID = merkvar sein!
                if ((merkvar) && (subID !== merkvar)) {
                    console.log('wird nicht geschrieben, weil subID des Blocks (' + subID + ') UNGLEICH der gemerkten SubID vom Anfang (' + merkvar + ')');
                    return;
                }
            };
            if (!merkvar && etype != "anhang") {
                merkvar = subID;
            };
            let newjson: any;
            let defaultwert: string = "";
            console.log(this.language,elang);
            if ((!elang) || (elang == this.language)) {
                if (etype == "string") {
                    // epart ist eine Zeichenfolge, die direkt so als Feldinhalt übernommen werden kann.
                    // String wird nur geschrieben, wenn keine Sprache hinterlegt ist => default-Wert für alle Sprachen oder der String für die gewählte Sprache verwendet werden soll.
                    hcontent = epart;
                    // returnvalue = this.myconcat([returnvalue, prestring, epart, poststring, subnotes]);
                    eparttp = epart;
                } else if ((etype == "json") || (etype == "htmltext")) {
                    // Die Angabe in epart ist ein FuD-Json-Feld, deren Wert direkt aus json übernommen werden kann.
                    // Funktion splitebenen liest hierarchische Wert korrekt aus, so kann hier auch nested Objekte, z.B. docTyp.name oder später LmAdd.gnd, wenn Model das  ausgelesen werden können.
                    //für w (und q-Felder) kann für die Webausgabe direkt der Link eingebettet werden. Wenn man das nicht möchte, kann man den Link auch als etype 'json' einbringen, dann wird nur der reine String übernommen und keine hyperlink auf den Inhalt gelegt.
                    //q-Feld noch nicht implementiert. Hier müsste noch der 1. Teil des Links definiert und gespeichert werden. Könnte man aber allgemein im Header hinterlegen. Könnte z.B. in epartpre stehen!

                    if (singlejson) {
                        console.log('706 ->' , elang, singlejson);

                        hcontent = singlejson[epart];
                    };
                    eparttp = epart;
                    if ((hcontent) && etype == "htmltext") {
                        let wrapper = document.createElement('div');
                        wrapper.innerHTML = hcontent;
                        let span = wrapper.getElementsByTagName("span");

                        let classes;
                        for (let spani = 0; spani < span.length; spani++) {
                            let spanclass1: string = span[spani].classList.toString();
                            // console.log(spanclass);
                            let spanclass2 = spanclass1.split(" ");
                            // console.log(spanclass);
                            if (classes) {
                                classes.push(spanclass2);
                            } else {
                                classes = [spanclass2];
                            };
                        };
                        // console.log(Array.isArray(classes));
                        // classes = sparseToDenseArray(classes.sort());
                        const unique = [...new Set(classes)];
                        // console.log("Feld " + hcontent + " enthält folgende Klassen: " + unique.toString());
                    };
                    if (this.stddefault == "epart") {
                        eparttp = `${epart}`;
                    };
                    if (epartusefct) {
                        //bei Funktionen werden auch epartpre und epartpost mitübergeben, da die z.B. bei Link einen Teil des Links enthalten können, z.B. Felder hat GND-Nummer und epartpre ist https://d-nb.info/gnd/.
                        //auch auf leere Inhalte können this.usefunction angewendet werden, da der subcontent ggf. weiteren Inhalt liefert => z.B. Linktext!
                        hcontent = this.usefunction(epartusefct, hcontent, epartsubcontent, singlejson, prestring, poststring, merkvar, "");
                        //da pre- und poststring in der Funktion verwendet worden sind, werden sie hier geleert, um Dopplungen zu verhindern.
                        //prestring = "";
                        //poststring = "";
                    };
                } else if (etype == "block") {
                    if (singlejson) {
                        newjson = singlejson[epart];
                    };
                    if (epartusefct) {
                        // hcontent = usefunction(epartusefct, hcontent, epartsubcontent, singlejson, prestring, poststring, merkvar, epartclass, epartclassend);
                        hcontent = this.usefunction(epartusefct, hcontent, epartsubcontent, singlejson, prestring, poststring, merkvar, "");
                    } else {
                        hcontent = this.getContent(epartsubcontent, newjson, blocktrenner, merkvar, "", "");
                    };
                    if (this.stddefault == "epart") {
                        eparttp = `${epart}.${hcontent}`;
                    };
                } else if ((etype == "child") || (etype == "LmAdd")) {
                    if (singlejson) {
                        newjson = singlejson[epart];

                        hcontent = this.getContent(epartsubcontent, newjson, blocktrenner, merkvar, "", "");

                    };
                    if (!merkvar) {
                        merkvar = subID;
                    };

                    if (epartusefct) {
                        //bei Funktionen werden auch epartpre und epartpost mitübergeben, da die z.B. bei Link einen Teil des Links enthalten können, z.B. Felder hat GND-Nummer und epartpre ist https://d-nb.info/gnd/.
                        //auch auf leere Inhalte können usefunction angewendet werden, da der subcontent ggf. weiteren Inhalt liefert => z.B. Linktext!
                        hcontent = this.usefunction(epartusefct, hcontent, epartsubcontent, singlejson, prestring, poststring, merkvar, "");
                        //da pre- und poststring in der Funktion verwendet worden sind, werden sie hier geleert, um Dopplungen zu verhindern.
                    };
                    if ((this.stddefault == "epart") && (etype == "child")) {
                        eparttp = `${epart}.${hcontent}`;
                    } else if ((this.stddefault == "epart") && (etype == "LmAdd")) {
                        eparttp = `${epart}.LmAdd.${hcontent}`;
                    };

                } else if (etype == "LmAdd_array") {
                    if (singlejson) {
                        newjson = singlejson.LmAdd;
                    };
                    if (!merkvar) {
                        merkvar = subID;
                    };
                    if (Array.isArray(newjson)) {
                        for (let ai = 0; ai < newjson.length; ai++) {
                            let newjson1 = newjson[ai];
                            if (newjson1.field == epart) {
                                let lmaddval = newjson1.val;
                                if (hcontent) {
                                    hcontent += hcontent + lmaddval;
                                } else {
                                    hcontent = lmaddval;
                                };
                                break;
                            };
                        };
                    };
                    if (epartusefct) {
                        //bei Funktionen werden auch epartpre und epartpost mitübergeben, da die z.B. bei Link einen Teil des Links enthalten können, z.B. Felder hat GND-Nummer und epartpre ist https://d-nb.info/gnd/.
                        //auch auf leere Inhalte können usefunction angewendet werden, da der subcontent ggf. weiteren Inhalt liefert => z.B. Linktext!
                        hcontent = this.usefunction(epartusefct, hcontent, epartsubcontent, singlejson, prestring, poststring, merkvar, "");
                        //da pre- und poststring in der Funktion verwendet worden sind, werden sie hier geleert, um Dopplungen zu verhindern.
                    };
                    if ((this.stddefault == "epart") && (etype == "child")) {
                        eparttp = `${epart}.${hcontent}`;
                    } else if ((this.stddefault == "epart") && (etype == "LmAdd")) {
                        eparttp = `${epart}.LmAdd.${hcontent}`;
                    };
                } else if (etype == "anhang") {
                    // in merkvar wird Zähler von oberste Ebene gespeichert, wie viele Anhänge/Bilder es geben kann (espez bei anhangblock).
                    let anhanginhalt;
                    let anhangzelle;
                    let hilfvar = epart + merkvar;
                    if (singlejson[hilfvar]) {
                        anhangzelle = singlejson[hilfvar];
                        if (epartusefct == "imgTags") {
                            if (anhangzelle.endsWith(".tif") || anhangzelle.endsWith(".jpg") || anhangzelle.endsWith(".png")) {
                                anhangzelle = `<img src="${anhangzelle}" alt="Anzeige von ${anhangzelle}">`;
                            };
                        };
                        if (anhanginhalt) {
                            anhanginhalt = this.myconcat([anhanginhalt, blocktrenner, prestring, anhangzelle, poststring]);
                        } else {
                            anhanginhalt = this.myconcat([prestring, anhangzelle, poststring]);
                        };
                    };
                    returnvalue = this.myconcat([returnvalue, epartclass, epartlabel, anhanginhalt, epartclassend, subnotes]);
                    if (this.stddefault == "epart") {
                        eparttp = hcontent;
                    };

                } else if (etype == "group") {
                    if (epartusefct) {
                        hcontent = this.usefunction(epartusefct, epart, epartsubcontent, singlejson, prestring, poststring, espez, merkvar);
                    } else {
                        hcontent = this.getContent(epartsubcontent, singlejson, returnvalue, merkvar, epartclass, epartclassend);
                    };
                    if (this.stddefault == "epart") {
                        eparttp = hcontent;
                    };
                } else if (etype == "linkgroup") {
                    if (!epartusefct) {
                        epartusefct = "inlink";
                    };
                    hcontent = this.usefunction(epartusefct, epart, epartsubcontent, singlejson, prestring, poststring, espez, merkvar);
                    if (this.stddefault == "epart") {
                        eparttp = hcontent;
                    };
                } else if (etype == "renderimage") {
                    hcontent = `<img src="${epart}" alt="Anzeige von ${epart}">`
                    if (this.stddefault == "epart") {
                        eparttp = `${epart} (Bildanzeige)`;
                    };
                } else if (etype == "search") {
                    let queryinhalt = mapdef[i].query;
                    if (queryinhalt) {
                        hcontent = this.fct_abqblock(this.dokid, epartsubcontent, queryinhalt, mapdef[i]);
                    } else {
                        hcontent = "Keine Suche nach abq-Feld spezifiziert!";
                    };
                    if (this.stddefault == "epart") {
                        eparttp = `${queryinhalt} (Suchfeld für ID in anderem Dokument)`;
                    };
                } else if (etype == "setPlaceholder") {
                    hcontent = this.getContent(epartsubcontent, singlejson, "", "", "", "");
                    this.placeholder[epart] = hcontent;
                    //da hcontent nur gespeichert, aber nicht noch geschrieben werden soll => hcontent muss hier wieder geleert werden, da sonst in Ausgabe berücksichtigt wird.
                    hcontent = "";
                    if (this.stddefault == "epart") {
                        eparttp = `Platzhalter ${epart}`;
                    };
                } else if (etype == "getPlaceholder") {
                    hcontent = this.placeholder[epart];
                    if (this.stddefault == "epart") {
                        eparttp = `Platzhalter ${epart}`;
                    };
                } else if (etype = "noshow") {
                    hcontent = "";
                    defaultwert = "";
                };
            } else {
                hcontent = "";
                defaultwert = "";
            };
            if ((this.stddefault == "epart") && (etype !== "noshow")) {
                let fudft;
                if (fudfeldtyp) {
                    fudft = `(${fudfeldtyp})`;
                };
                let hilfausgabe = this.myconcat([eparttp, fudft]);
                returnvalue = this.myconcat([returnvalue, epartclass, epartlabel, '<span class="anderefarbe">', prestring, '</span>', hilfausgabe, '<span class="anderefarbe">', poststring, '</span>', epartclassend, subnotes]);
            } else if (hcontent) {
                returnvalue = this.myconcat([returnvalue, epartclass, epartlabel, prestring, hcontent, poststring, epartclassend, subnotes]);
            } else if (edefault) {
                if (!elang || (this.language == elang)) {
                    let defaultwert = this.getContent(edefault, singlejson, returnvalue, merkvar, epartclass, epartclassend);
                    returnvalue = this.myconcat([returnvalue, epartclass, epartlabel, prestring, defaultwert, poststring, epartclassend, subnotes]);
                }
            } else if ((this.stddefault !== "ohne") && (etype !== "noshow")) {
                returnvalue = this.myconcat([returnvalue, epartclass, epartlabel, prestring, this.stddefault, poststring, epartclassend, subnotes]);
            };
            if ((etype == "json") || (etype == "string")) {
            };
            // console.log(`Rückgabe2: ${returnvalue}`);
        };
        return returnvalue;
    }

    readlabel(labelarray: any, language: string) {
        //ohne Label wird div-label auch nicht geschrieben!
        let labelinlang: string = "n/a";
        if (!labelarray) {
            return labelinlang;
        } else {
            for (let li = 0; li < labelarray.length; li++) {
                // wenn keine Sprache für Label angegeben ist, wird das als default-Wert verwendet, der vom Sprachlabel überschrieben werden kann.
                let labellang = labelarray[li].lang;
                if (!labellang) {
                    labelinlang = labelarray[li].labelstring;
                } else if (labellang == language) {
                    labelinlang = labelarray[li].labelstring;
                    return labelinlang;
                };
            };
            if (!labelinlang) {
                labelinlang = "n/a";
            };
            return labelinlang;
        };
    }

    usefunction(fctname, epartinhalt, subcontent, datablock, pre, post, spez, blockid) {
        // Hier können Funktionen aufgerufen werden, z.B. um einen Link zurück zu bekommen oder Inhalt aus einem andere Dokument zu beziehen.
        // Diese Funktion wird nur als Verteiler für die einzelen Funktionen gebraucht, damit man die if-Schleife nicht an jede Stelle des Programms schreiben muss. Der eigentliche Inhalt
        // ------------   BISHER DEFINIERTE USEFUNCTIONS --------------------------------------
        // - inlink: Interner Link zu einem anderen FuD-Dokument: als subcontent können auch Felder aus dem anderen Dokument angegeben werden. Hierfür muss das q-Feld im subcontent nochmal als epart mit der usefunction "readContentDiffDoc" eingetragen sein. Der nun folgede subcontent wird dann aus dem anderen Dokument gelesen.
        // - inlink:
        // - exlink: 
        // - readContentDiffDoc:
        // - dateformat:
        // - turnCommaParts: 
        // - findeabqDocs: 
        // - readabqDocs: 
        let rueckgabe: string = "";
        if ((fctname == "inlink") || (fctname == "exlink")) {
            //inlink: Interner Link auf ein weiteres Dokument innerhalb der FuD-Instanz.
            // neu: seit 2022-03-22
            // inlink wird aus etype 'linkgroup' aufgebaut, die ein 'linktarget' und ein 'linkcontent' als subcontent beinhaltet. Wird 'linkcontent' weggelassen, wird 'linktarget' gedoppelt und zusätzlich auch als 'linkcontent' verwendet.
            let linktarget: string = "";
            let linkcontent: string = "";
            if (subcontent[0]) {
                if (subcontent[0].etype = "linktarget") {
                    linktarget = subcontent[0].subcontent;
                } else if (subcontent[0].etype = "linkcontent") {
                    linkcontent = subcontent[0].subcontent;
                    let hilf1 = subcontent[0].etype;
                    let error = `Linkgroup-Subcontent: Hier steht falscher etype: sollte linktarget und linkcontent sein, ist aber ${hilf1}`;
                    console.log(error);
                };
            };
            if (subcontent[1]) {
                if (subcontent[1].etype = "linkcontent") {
                    linkcontent = subcontent[1].subcontent;
                } else {
                    let hilf1 = subcontent[1].etype;
                    let error = `Linkgroup-Subcontent: Hier steht falscher etype: sollte linktarget und linkcontent sein, ist aber ${hilf1} oder ist leer!`;
                    console.log(error);
                };
            };
            if (!linkcontent) {
                linkcontent = linktarget;
            };
            // console.log(spez);
            // console.log(datablock);
            // console.log(linktarget);
            // console.log(linkcontent);
            if (blockid == "67") {
                debugger;
            };
            let inlink = this.fct_inlink(linktarget, linkcontent, datablock, blockid);
            if (inlink) {
                rueckgabe = this.myconcat([pre, inlink, post]);
            };
        } else if (fctname == "readContentDiffDoc") {
            //q-Feldverknüpfung: liest den Inhalt aus einem anderen Dokument: DocID wird mit epartinhalt übergeben, Felder des anderen Dokuments stehen im subcontent! Dafür muss aber completejson eine Liste von Dokumenten sein, sonst funktioniert es nicht. Bei letzterem wird dann defaultwert geschrieben.
            let jsonsucharray: any = [];
            if (Array.isArray(this.completejson)) {
                jsonsucharray = this.completejson;
            } else {
                jsonsucharray = [this.completejson];
            };
            let diffDoc: any;
            for (let findi = 0; findi < jsonsucharray.length; findi++) {
                let fuddoc = jsonsucharray[findi];
                if (fuddoc._id == epartinhalt) {
                    diffDoc = fuddoc._source;
                    break;
                };
            };
            if (diffDoc) {
                rueckgabe = this.getContent(subcontent, diffDoc, "", "", "", "");
            } else if (this.stddefault == "epart") {
                rueckgabe = this.myconcat(["usefct:readContentDiffDoc(", epartinhalt, ")"]);
            } else if (this.stddefault !== "ohne") {
                rueckgabe = this.stddefault;
            };
            if (this.stddefault == "epart") {
                rueckgabe = this.myconcat(["usefct:readContentDiffDoc(", rueckgabe, ")"]);
            };
        } else if (fctname == "turnCommaParts") {
            //dreht den Inhalt der Variablen epartinhalt am Komma und löscht das Komma. Term wird konsequent von hinten nach vorne gedreht: Müller, Peter, Dr., Prof. => Prof. Dr. Peter Müller, Meier, Ralf, Bischof => Bischof Ralf Meier
            let hilf = epartinhalt.split(", ");
            rueckgabe = hilf.reverse().join(" ");
        } else if (fctname == "dateformat") {
            if (epartinhalt) {
                let dateval = this.fct_styledates(epartinhalt, subcontent);
                //pre und post werden immer mitübergeben, da für Linkfunktionen wichtig => pre und post müssen hier gesetzt werden. Eigentlich müsste hier IMMER Datum zurückkommen, bei Fehler zumindest "invalid Date".
                if (dateval) {
                    //pre und post müssen hier nicht gesetzt werden, da dies schon bei der Datenübergabe eine Ebene drüber erfolgt.
                    rueckgabe = this.myconcat([dateval]);
                };
            };
        } else if (fctname == "findeabqDocs") {
            //#todo nur noch etype "search" umsetzen!
            // ab-Felder: da completejson eine globale Variabel ist, muss der Inhalt des gesamten JSON-Dokument nicht explizit mit übergeben werden.
            //this.dokid ist globale Variabel, die die ID des json-Elements = FuD-Dokuments enthält!
            //epartinhalt = query!
            rueckgabe = this.fct_abqblock(this.dokid, subcontent, epartinhalt, "");
            if (this.stddefault == "epart") {
                rueckgabe = this.myconcat(["usefct:findeabqDocs(", spez, "):", rueckgabe]);
            } else if ((this.stddefault !== "ohne") && (!rueckgabe)) {
                rueckgabe = this.myconcat(["usefct:findeabqDocs(", spez, "):", this.stddefault]);
            };
            //} else if (fctname == "readabqDocs") {
            // wird nur durch findeabqDocs aufgerufen => hier kein weiterer Programmcode!
        } else if (fctname == "getParent") {
            // Abfrage, wie parent heißt. #TODO müsste an elastic angeschlossen werden.
            // ID in analyse finden => content und parentID zurückgeben. 
            // rückgabewert = this.myconcat [content,pre,rückgabewert] (wird immer davor gesetzt!)
            // Wenn parentID > 0, Vorgang wiederholen.
            // rueckgabe = getParent(epartinhalt);
            rueckgabe = epartinhalt;
        } else {
            console.log(`Diese Funktion ${fctname} ist nicht bekannt! Bitte Programmautor informieren!`);
        }
        return rueckgabe;
    }

    fct_inlink(href, linkcontent, jsonblock, qid) {
        let linkref;
        let linkende;
        let linktarget;
        if (href) {
            let noblocktarget;
            linktarget = this.getContent(href, jsonblock, noblocktarget, qid, "", "");
        };
        let otherid = parseInt(linktarget);
        if (Number.isInteger(otherid)) {
            //nur für meine Vorschauausgabe! Hier wird zu einem Id sind hier als Ankerpunkte gesetzt, zu denen man springen kann. In Onlineversion müsste hier diese ID an Linkstring angehängt werden.
            let linktargetneu = `#${linktarget}`;
            linkref = `<a href='${[linktargetneu]}'>`;
            linkende = `</a>`;
        } else if (linktarget) {
            linkref = `<a href='${[linktarget]}'>`;
            linkende = `</a>`;
        };
        let noblock: string = "";
        let linktext: string = "";
        if (linkcontent) {
            linktext = this.getContent(linkcontent, jsonblock, noblock, qid, "", "");
        };
        if (linktext) {
            linkref = this.myconcat([linkref, linktext, linkende]);
        } else if (linktarget) {
            //Konvention: Wenn kein Linkinhalt da ist, wird der Link selber als Anzeigetext des Links gebraucht.
            linkref = this.myconcat([linkref, linktarget, linkende]);
        };
        return linkref;
    }

    fct_styledates(epart, epartsub) {
        const event = new Date(epart);
        let options;
        //momentan wird angenommen, dass nur ein Format angegeben ist.
        // #TODO_23: zu überlegen, ob man auch mehrere angeben kann für andere Sprachen und das dann als Abfrage mit der Seitensprache abgeglichen werden kann.
        // ---------------- BISHER DEFINIERTE DATUMSFORMATE ------------------------
        // * YYYY-MM-DD: wird alles nummerisch mit führenden Nullen wiedergegeben.
        // * YYYY-MMM-DD: Monat wird in Sprache ausgegeben. Jahr und Tag mit führenden Nullen angegeben.
        // * +T: kann an Datumsformat ergänzt werden, wenn ein Zeitformat folgt. Zeitformat wird in angegebenen Sprachformat ausgegeben.
        let espez;
        let elang;
        if (this.stddefault == "epart") {
            return "usefct:dateformat";
        } else if ((this.stddefault !== "ohne") && (!epart)) {
            return this.stddefault;
        };
        if (Array.isArray(epartsub)) {
            for (let n = 0; n < 1; n++) {
                espez = epartsub[n].epart;
                elang = epartsub[n].elang;
            };
        } else {
            espez = epartsub.epart;
            elang = epartsub.elang;
        };
        if (!elang) {
            elang = "de-DE";
        };
        // Datumsformat
        if (espez.startsWith("YYYY-MMM-DD")) {
            options = { year: 'numeric', month: 'long', day: 'numeric' };
        } else if (espez.startsWith("YYYY-MM-DD")) {
            options = { year: 'numeric', month: 'numeric', day: 'numeric' };
        };
        //Gibt wohl immer alles zurück: wenn Tag oder Monat undefiniert => 1 wird geschrieben, so dass nur einen Jahresangaben => 1.1.Jahresangabe wird!
        //#TODO: Überprüfung, ob Jahr, Monat, Tag vorhanden. Wenn nicht => Anpassung des Datumsformats!
        let datestring = event.toLocaleDateString(elang, options);
        // Zeitformat: momentan wird das nur komplett ausgegeben!
        if (espez.endsWith("+T")) {
            let timestring = event.toLocaleTimeString(elang);
            datestring = this.myconcat([datestring, " ", timestring]);
        };
        return datestring;
    }

    fct_abqblock(findeID, subcontent, query, searchdef) {
        // In findeID steht die ID des FuD-Dokuments, das ein q-Feld in sich besitzt, dessen Wert mit der ID übereinstimmt.
        // Eigentlich sollte direkt das 1. Element des subcontents, das JSON-Element sein, in dem gesucht wird. #TO_CHECK: macht es Sinn hier das array zu durchlaufen, um ggf. Strings etc. voran zu stellen. Ich denke erstmal nicht, aber man könnte es theoretisch mit getContent schon realisieren, obwohl man noch einen Parameter mehr brauchen wurde (das eigentlich Docjson!).
        // #TO_DO: q-Feld in s-Feld: Was macht da für einen Unterschied?
        // da completejson eine globale Variable ist, braucht der Inhalt nicht mitübergeben zu werden.
        let rueckgabe;
        let findeinfeld = query;
        let findeetype;
        if (query.includes(".")) {
            findeetype = "block"
        } else {
            findeetype = "json"
        };
        let elang = searchdef.elang;
        let abqfelder = subcontent;
        let trenner = searchdef.blocktrenner;
        let epartclass = searchdef.eclass;
        let epartclassend;
        if (epartclass) {
            epartclass = `<div class='${epartclass}'>`;
            epartclassend = `</div>`;
        };
        //elabel ist ein Array, das objects mit labelstring und lang enthält. 
        let labelresult = this.readlabel(searchdef.elabel, elang);
        let labelinlang = labelresult['labelinlang'];
        let epartlabelclass = labelresult['labelclass'];
        // Wenn eine Klasse für ein Label angegeben ist, z.B. inline, um das Label ohne weitere Formatierung vor den content zu setzen, MUSS es angegeben werden. Ansonsten wird, wenn ein Label angegeben ist, die Klasse 'sublabel' verwendet!
        // Wenn kein Label angegeben ist, wird auch kein div-Tag für das Label geschrieben.
        let epartlabel: string = "";
        if (labelinlang && epartlabelclass) {
            epartlabel = `<div class='${epartlabelclass}'>${labelinlang}</div>`;
        } else if (labelinlang) {
            epartlabel = `<div class='sublabel'>${labelinlang}</div>`;
        };
        let mainfeld;
        let subfeld;

        if (findeetype == "block") {
            mainfeld = findeinfeld;
            subfeld = abqfelder[0].epart;
            findeetype = "searchsub";
            abqfelder = abqfelder[0].subcontent;
        } else {
            mainfeld = findeinfeld;
        };
        let founddocs = new Array();
        //dokid ist globale Variable, in der die DBID des Dokuments gespeichert wird. Um diese auch für andere Dokumente zu nutzen, muss sie hier umgestellt werden. Wenn man aber mit den Aktion in den anderen Dokumenten fertig ist, wird die dokid wieder auf Anfangswert predokid gesetzt.
        let predokid = this.dokid;
        for (let dii = 0; dii < this.completejson.length; dii++) {
            //lies das Feld q-Feld von jedem Dokument und vergleiche es mit findeID.
            let singlejson = this.completejson[dii]._source;
            this.dokid = singlejson.ID;
            if (findeetype == "searchsub") {
                //q-Feld ist in einem wiederholbaren Block => muss jeden Block durchlaufen und dann das q-Feld vergleichen.
                let qfeldarray = singlejson[mainfeld];
                if (qfeldarray) {
                    let savedii = dii;
                    for (let bii = 0; bii < qfeldarray.length; bii++) {
                        let einzelblock = qfeldarray[bii];
                        let qfeldval = einzelblock[subfeld];
                        if (qfeldval == findeID) {
                            let felder;
                            founddocs.push(this.dokid);
                            let savebii = bii;
                            for (let b2i = 0; b2i < abqfelder.length; b2i++) {
                                // über die writeoption wird kontrolliert, ob das Feld aus dem Block stammt, in dem das q-Feld sich befindet, oder ob ein Feld aus der übergeordneten Hauptebene eingetragen werden soll. Prinzipell sollten nur Felder aus dem Block bzw. aus der Hauptebene zurückgegeben werden.
                                let woption = abqfelder[b2i].writeoption;
                                let felderincore;
                                if (woption == "reloadjson4doc") {
                                    //bei der Option 'reloadjson4doc' wird ein Felder auf der obersten Ebene des Dokuments ausgelesen => singlejson muss verwendet werden.
                                    felderincore = this.getContent(abqfelder[b2i], singlejson, "", "", "", "");
                                } else {
                                    //wenn nichts angegeben oder eben etwas anderes angegeben ist => es werden Felder aus dem Block ausgelesen.
                                    felderincore = this.getContent(abqfelder[b2i], einzelblock, "", "", "", "");
                                };
                                if (felder) {
                                    felder = this.myconcat([felder, felderincore]);
                                } else {
                                    felder = felderincore;
                                };
                            };
                            bii = savebii;
                            if (rueckgabe) {
                                rueckgabe = this.myconcat([rueckgabe, trenner, epartlabel, epartclass, felder, epartclassend]);
                            } else {
                                rueckgabe = this.myconcat([epartlabel, epartclass, felder, epartclassend]);
                            };
                        };
                    };
                    dii = savedii;
                };
            } else {
                let qfeldval = singlejson[mainfeld];
                if (qfeldval == findeID) {
                    founddocs.push(this.dokid);
                    let savedii = dii;
                    let felder = this.getContent(abqfelder, singlejson, "", "", "", "");
                    // console.log(felder);
                    if (rueckgabe) {
                        rueckgabe = this.myconcat([rueckgabe, epartlabel, epartclass, felder, epartclassend]);
                    } else {
                        rueckgabe = this.myconcat([epartlabel, epartclass, felder, epartclassend]);
                    };
                    dii = savedii;
                };
            };

        };
        this.dokid = predokid;
        if ((this.stddefault !== "ohne") && (!rueckgabe)) {
            rueckgabe = `${this.stddefault}`;
        };

        return rueckgabe;
    }

    checkwelement(content, bedingungsarray) {
        let bedingungerfuellt: boolean = false;
        let operator = bedingungsarray[1];
        let vglwert = bedingungsarray[2];

        if (operator == "NE") {
            if (content !== vglwert) {
                bedingungerfuellt = true;
            } else {
                bedingungerfuellt = false;
            };
        } else if (operator == "EQ") {
            if (content == vglwert) {
                bedingungerfuellt = true;
            } else {
                bedingungerfuellt = false;
            };
        };
        // console.log(bedingungerfuellt);
        return bedingungerfuellt;
    }
}